export default __webpack_public_path__ + "static/0239-300c584d704a3d6e4dce555f900b2167.png";